import { useEffect } from 'react';

export const useRegisterZone = (
  slotId: string,
  options?: {
    skip: boolean;
  }
): void => {
  const { skip } = options || {};

  useEffect(() => {
    if (skip) {
      return;
    }

    const fusetag = window.fusetag || (window.fusetag = { que: [] });
    fusetag.que.push(() => {
      fusetag.registerZone?.(slotId);
    });
  }, [skip, slotId]);
};
